var _path, _polygon, _g, _path2, _polygon2, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255.1 59.6",
    enableBackground: "new 0 0 255.1 59.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1A1B",
    d: "M27,17.8l2.5,9.5H24L27,17.8z M16.9,0L0,44.2h18.2l2.5-7.4h11.6l2.2,7.4h21.2L38.6,0H16.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1D1A1B",
    points: "55.7,0 55.7,44.2 98.1,44.2 98.1,30 76.4,30 76.4,0 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 255.1,
    height: 59.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013915444441485457140000007600188048310370959_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000013915444441485457140000007600188048310370959_)",
    fill: "#1D1A1B",
    d: "M178.7,0v16.8h-10.2V0h-20.7 v14c0-7.8-6.1-14-17.9-14H99.1v44.2h20.7V30.4h10.5c11.7,0,17.5-6.6,17.5-14.5v28.3h20.7V28.8h10.2v15.4h20.7V0H178.7z M127,17.7 c0,2.1-1,3.3-3.9,3.3h-3.4v-8.4h3.4c2.9,0,3.9,1.1,3.9,3.3V17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000013915444441485457140000007600188048310370959_)",
    fill: "#1D1A1B",
    d: "M238,0h-21.6l-16.9,44.2 h18.2l2.5-7.4h11.6l2.2,7.4h21.2L238,0z M223.4,27.3l3-9.5l2.5,9.5H223.4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#48A247",
    d: "M58.7,55.9l0.7,1.6h-1.3L58.7,55.9z M58.3,54.6l-2.1,5h1.1l0.5-1.1h2.1l0.5,1.1h1.1l-2.1-5H58.3z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#48A247",
    points: "66,54.6 66,59.5 69.5,59.5 69.5,58.5 67.1,58.5 67.1,54.6 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000103984151180321338400000001445805997238657153_",
    y: 0,
    width: 255.1,
    height: 59.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097475285000806098700000000441381270168627853_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103984151180321338400000001445805997238657153_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    d: "M76.2,54.6h-2v4.9h1.1V58 h0.8c1.1,0,2-0.6,2-1.7v0C78.1,55.3,77.4,54.6,76.2,54.6 M77,56.3c0,0.4-0.3,0.7-0.9,0.7h-0.9v-1.5h0.8C76.7,55.6,77,55.8,77,56.3 L77,56.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    points: "85.8,56.5  83.9,56.5 83.9,54.6 82.8,54.6 82.8,59.5 83.9,59.5 83.9,57.5 85.8,57.5 85.8,59.5 86.9,59.5 86.9,54.6 85.8,54.6  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    d: "M93.7,54.6l-2.1,5h1.1 l0.4-1.1h2.1l0.5,1.1h1.1l-2.1-5H93.7z M93.5,57.5l0.7-1.6l0.7,1.6H93.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    points: "101.4,59.5  102.5,59.5 102.5,57.6 104.8,57.6 104.8,56.6 102.5,56.6 102.5,55.6 105.1,55.6 105.1,54.6 101.4,54.6  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    d: "M114,56.2L114,56.2 c0-1-0.7-1.6-1.9-1.6h-2.2v4.9h1.1v-1.6h0.9l1.1,1.6h1.3l-1.2-1.8C113.6,57.5,114,57,114,56.2 M112.9,56.3c0,0.4-0.3,0.7-0.8,0.7 H111v-1.4h1.1C112.6,55.6,112.9,55.8,112.9,56.3L112.9,56.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    points: "119.9,57.5  122.2,57.5 122.2,56.6 119.9,56.6 119.9,55.6 122.5,55.6 122.5,54.6 118.8,54.6 118.8,59.5 122.6,59.5 122.6,58.6 119.9,58.6  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    d: "M129.4,56.6 c-0.8-0.2-1.1-0.3-1.1-0.6v0c0-0.2,0.2-0.4,0.6-0.4c0.4,0,0.8,0.2,1.3,0.5l0.6-0.8c-0.5-0.4-1.1-0.6-1.8-0.6c-1,0-1.7,0.6-1.7,1.5 v0c0,1,0.6,1.3,1.6,1.5c0.8,0.2,1,0.4,1,0.6v0c0,0.3-0.3,0.5-0.7,0.5c-0.6,0-1-0.2-1.5-0.6l-0.6,0.8c0.6,0.5,1.3,0.8,2.1,0.8 c1.1,0,1.8-0.5,1.8-1.5v0C131,57.2,130.4,56.8,129.4,56.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    points: "138.8,56.5  136.8,56.5 136.8,54.6 135.8,54.6 135.8,59.5 136.8,59.5 136.8,57.5 138.8,57.5 138.8,59.5 139.9,59.5 139.9,54.6 138.8,54.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.8,
    y: 58.4,
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    width: 1.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    d: "M152.9,58.6 c-0.8,0-1.4-0.7-1.4-1.5v0c0-0.8,0.6-1.5,1.4-1.5c0.5,0,0.9,0.2,1.3,0.6l0.7-0.8c-0.5-0.4-1-0.8-1.9-0.8c-1.5,0-2.6,1.1-2.6,2.5v0 c0,1.4,1.1,2.5,2.5,2.5c0.9,0,1.5-0.3,2-0.9l-0.7-0.7C153.8,58.4,153.5,58.6,152.9,58.6"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    d: "M161.9,54.5 c-1.5,0-2.6,1.1-2.6,2.5v0c0,1.4,1.1,2.5,2.6,2.5c1.5,0,2.6-1.1,2.6-2.5v0C164.5,55.6,163.4,54.5,161.9,54.5 M163.4,57.1 c0,0.8-0.6,1.5-1.5,1.5s-1.5-0.7-1.5-1.5v0c0-0.8,0.6-1.5,1.5-1.5C162.7,55.5,163.4,56.2,163.4,57.1L163.4,57.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    points: "171.8,56.7  170.5,54.6 169.3,54.6 169.3,59.5 170.4,59.5 170.4,56.3 171.8,58.4 171.8,58.4 173.2,56.3 173.2,59.5 174.2,59.5 174.2,54.6  173.1,54.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.1,
    y: 58.4,
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    width: 1.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    d: "M186.9,54.6l-2.1,5h1.1 l0.5-1.1h2.1l0.5,1.1h1.1l-2.1-5H186.9z M186.7,57.5l0.7-1.6l0.7,1.6H186.7z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000097475285000806098700000000441381270168627853_)",
    fill: "#48A247",
    d: "M197.5,57.4 c0,0.8-0.4,1.2-1.1,1.2c-0.7,0-1.1-0.4-1.1-1.2v-2.8h-1.1v2.8c0,1.4,0.8,2.2,2.1,2.2c1.3,0,2.2-0.7,2.2-2.2v-2.8h-1.1V57.4z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.0c9dbcd3edd762705df816623e0b39e6.svg";
export { ForwardRef as ReactComponent };